import { render, staticRenderFns } from "./kpsrPlanInfo.vue?vue&type=template&id=7f2e5f8b"
import script from "./kpsrPlanInfo.vue?vue&type=script&lang=js"
export * from "./kpsrPlanInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2e5f8b')) {
      api.createRecord('7f2e5f8b', component.options)
    } else {
      api.reload('7f2e5f8b', component.options)
    }
    module.hot.accept("./kpsrPlanInfo.vue?vue&type=template&id=7f2e5f8b", function () {
      api.rerender('7f2e5f8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/plan/kpsrPlanInfo.vue"
export default component.exports